import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';

@Component({
  selector: 'app-overlay-disposition',
  templateUrl: './overlay-disposition.component.html',
  styles: [
  ]
})
export class OverlayDispositionComponent extends ExcTranslation implements OnInit {
  // Version DispoList 2 & Dispo Map3

  @Input()
  set data(value: any) {
    if (value) {
      this._data = value;
    }
  }
  get data(): any {
    return this._data;
  }
  private _data: any = {};

  mode = 'DL';
  busy = false;

  SummaryData = {
    isLoading: true,
    searchValue: '',
    multiRoute: true,
    data: {} as any,
    schadenortData: [] as any[],
    oeData: [] as any[],
    selected: [] as any[],
    selectedObjects: [] as any[],
    state: 1,
    uiFilterEnumGroup: [
      {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang', defaultValues: [1, 16, 2, 14, 3, 23, 24]},
      {enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false, enmAltTT: true}
    ],
    uiFilterSearchFields: [
      {tableField: 'adrPlz', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'adrOrt', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'adrStr', table: 'Adresse', groupCaption: 'Schadenort'},
      {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'vorgNr', table: 'Vorgang'},
      {tableField: 'Bearbeiter', table: 'Vorgang'},
      {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
      {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
      {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
      {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
      {tableField: 'auAnsprechpartner', table: 'Auftrag'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrPlz'},
      {fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrOrt'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any [],
    uiSort: [] as any [],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    changeMultiRoute: (): void => {
      if (this.mode === 'DL') {
        this.mode = 'QS';
      } else if (this.mode === 'QS') {
        this.mode = 'DL';
      }
      this.loadSummaryData();
      // this.VCDispoMap2.refreshDestinations();
    },
    rowChange: (index: number) => {
      if (index === -1) {
        return;
      }
      if (!this.SummaryData.selectedObjects.find((sOrt: any) => sOrt === this.SummaryData.schadenortData[index])) {
        // this.VCSOlist.select(index, true);
      } else {
        // this.VCSOlist.select(index, false);
      }
    },
    itemSelect: (index: number) => {
      this.SummaryData.selectedObjects = [...this.SummaryData.selectedObjects];
      /*            this.VCDispoMap2.updateMarkers();
                  this.VCDispoMap2.refreshDestinations();*/
    },
    pageChanged: (page: number): void => {
      if (this.SummaryData.MetaInfo.dataPaging !== undefined) {
        this.SummaryData.MetaInfo.dataPaging.pageNo = page;
      }
    },
    ready: () => {
      if (this.SummaryData.schadenortData.length === 0) {
        this.SummaryData.state = 2;
      } else {
        this.SummaryData.state = 0;
      }
      this.SummaryData.isLoading = false;
    },
    loadData: (data: any, paging: any): void => {
      this.SummaryData.data = data;
      this.SummaryData.schadenortData = (this.mode === 'QS') ? data.SchadenorteQS : data.Schadenorte;

      // this.SummaryData.paging = paging.Schadenorte;
      this.SummaryData.selectedObjects = [this.SummaryData.schadenortData[0]];
      this.SummaryData.oeData = (this.mode === 'QS') ? data.QS : data.DL;
      if (this.SummaryData.oeData.length > 0) {
        for (const dlElement of this.SummaryData.oeData) {
          Object.assign(dlElement, {
            assignedTasks: ExcCoreModule.Array.GetAll(
              this.SummaryData.data.DisponiertSchadenorteDL,
              'vorg_oid_Bearbeiter',
              dlElement.oeID
            )
          });
          Object.assign(dlElement, {
            assignedTasksRegions: [],
            assignedTasksRegionsShort: []
          });
          ExcCoreModule.Array.GetAll(
            this.SummaryData.data.DisponiertSchadenorteDL,
            'vorg_oid_Bearbeiter',
            dlElement.oeID
          ).forEach((task: any) => {
            if (task.adrPlz) {
              // Task PLZ: 2 Stellen
              dlElement.assignedTasksRegions.push(task.adrPlz.slice(0, 2));
              // Task PLZ: Stelle 1
              const region = dlElement.assignedTasksRegionsShort.find(
                (postCode: any) => postCode?.postCode === task.adrPlz.slice(0, 1)
              );
              if (!!region && (task.adrPlz && task.adrPlz.startsWith(region.postCode))) {
                region.count = region.count + 1;
              } else {
                dlElement.assignedTasksRegionsShort.push({postCode: task.adrPlz.slice(0, 1), count: 1});
              }
            }
          });

          // Sort: assignedTasksRegionsShort
          dlElement.assignedTasksRegionsShort =
            dlElement.assignedTasksRegionsShort
              .sort((dlPostCode1: any, dlPostCode2: any) =>
                dlPostCode1 && dlPostCode2 && dlPostCode1.postCode > dlPostCode2.postCode ? 1 : -1
              );

          // Sort: assignedTasksRegions
          dlElement.assignedTasksRegions =
            ExcCoreModule.Array
              .Distinct(dlElement.assignedTasksRegions)
              .sort((dlPostCode1: string, dlPostCode2: string) => dlPostCode1 > dlPostCode2 ? 1 : -1);
        }
      }
    },
  };

  constructor(
    public modalSvc: ExgModalService,
    public overlayService: ExgOverlayService,
    public excRestService: ExcRestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadSummaryData();
  }

  loadSummaryData(): void {
    this.SummaryData.oeData = [];
    this.SummaryData.isLoading = true;
    this.SummaryData.state = 1;
    // this.VCSOlist.selectSource = [];
    // this.VCSOlist.selectSourceRows = [];
    this.SummaryData.selectedObjects = [];
    this.excRestService.get(
      this.excRestService.computeUrl('TaskDispositionR_Summary', {vorgID: this.data.vorgID})
      , {MetaInfo: this.SummaryData.MetaInfo}
    ).subscribe((result) => {
      this.SummaryData.loadData(result.data, result.paging);
      this.SummaryData.ready();
    });
  }


  assignTasks(event: any): void {
    if (this.busy) {
      return;
    }
    const assignList: any[] = [];

    for (let i = 0; i < this.SummaryData?.selectedObjects?.length; i++) {
      assignList.push({
        vorgID: this.SummaryData.selectedObjects[i].vorgID,
        oeID: event.oeID,
        vorgUPT: this.SummaryData.selectedObjects[i].vorgUPT
      });
    }


    if (assignList.length > 0) {
      const seen: {[vorgID: number]: boolean} = {};
      const uniqueTasks = this.SummaryData.selectedObjects.filter((task: any) => {
        if (seen[task.vorgID]) {
          return false;
        }
        seen[task.vorgID] = true;
        return true;
      });

      const seenAssign: {[vorgID: number]: boolean} = {};
      const uniqueAssignList = assignList.filter((item: any) => {
        if (seenAssign[item.vorgID]) {
          return false;
        }
        seenAssign[item.vorgID] = true;
        return true;
      });
      this.modalSvc.show('ModalAssignConfirmationComponent'
        , {
          title: this.getRessource('Toast.title'),
          tasks: uniqueTasks,
          DL: {fullName: event.oeName + ', ' + event.oeEName},
          mode: this.mode
        }
        , true).subscribe((answer: any) => {
        if (answer?.assign) {
          let mode = this.mode;
          if (answer?.mode) {
            mode = answer.mode;
          }
          this.busy = true;
          this.excRestService.put(
            this.excRestService.computeUrl('TaskU_MultiAssign')
            , {assignList: uniqueAssignList, mode, sendCaseAcceptToClient: answer.sendCaseAcceptToClient}
          ).subscribe((ret) => {
            if (ret.success) {
              this.SummaryData.selectedObjects = [];
              this.modalSvc.showToast(
                this.getRessource('Toast.assigned')
                , 'md-toast bg-green', 'fa-duotone fa-arrows-down-to-people');
              this.overlayService.action({assigned: true});
            } else {
              this.modalSvc.showToast(
                this.getRessource('Toast.notAssigned')
                , 'md-toast bg-orange'
                , 'fas fa-exclamation'
                );
              this.overlayService.action({assigned: false});
            }
            this.busy = false;
          });
        }
      });
    }
  }

  placeClick($event: any): void {
    // if (this.SummaryData.multiRoute) {
    //   const selectedIndex = this.SummaryData.selectedObjects.findIndex((so: any) => {
    //     return so.vorgID === $event.vorgID;
    //   });
    //   const index = this.SummaryData.schadenortData.findIndex((so: any) => {
    //     return so.vorgID === $event.vorgID;
    //   });
    //   if (index > -1) {
    //     // this.VCSOlist.select(index, (selectedIndex === -1) ? true : false);
    //   }
    // } else {
    //
    // }
  }
}
